import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../template/store';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { useEffect, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import DataTable from '../../common/components/DataTable';
import {
  // deleveryLocTypeList,
  extensionTypeList,
  // returnLocTypeList,
} from '../dashboard/actions/instruction';
import { getInvoiceRequestSubLocationList } from './InvoiceRequestActions';
import { getCurrencyDDList, getCurrencyDDListByBankNm } from '../blPayment/actions/payments';
import useDataCountry from '../../../hooks/useDataCountry';
// import useBlCountry from '../../../hooks/useBlCountry';
// import useInvoiceRequestBlCountry from '../../../hooks/useInvoiceRequestBlCountry';
import { getDateFormat } from '../../../helpers/dateFormat';
import { IDataTableColumn } from '../../common/types/dataTable';
import moment from 'moment';
import {
  updateSelectedCCyOnContainer,
  updateSelectedCcy,
  updateSelectedDeliveryZone,
  updateSelectedModeOfTransport,
  updateSelectedSubLocation,
  updateSelectedTypeOfTrailer,
  updateContainerTransportField,
  updateSelectedContainerNo,
  updateSelectedPickupDate,
  updateSelectedPlannedPickupDate,
  updateSelectedneedExtensionFor,
} from './InvoiceRequestContainerSlice';
import { setDirty } from '../formDirtySlice';
import { updateColsDataTable } from '../../common/components/DataTable/slices/DataTable';

type InvoiceRequestContainerDetailsProps = {
  disableFields: boolean;
  isDemurrageDetentionSelected: boolean;
  disabledPath: boolean;
  country: string | null;
  blId?: string;
  deliveryZoneList: Array<{ value: string | number; label: string }>;
  modeOfTransportList: Array<{ value: string | number; label: string }>;
  typeOfTrailerList: Array<{ value: string | number; label: string }>;
};

const InvoiceRequestContainerDetails = ({
  disableFields,
  isDemurrageDetentionSelected,
  disabledPath,
  country,
  blId: blIdProp,
  deliveryZoneList,
  modeOfTransportList,
  typeOfTrailerList,
}: InvoiceRequestContainerDetailsProps) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { blNum } = useParams();
  // const isInstructionDashboardNewForm = !blNum;
  // const [blCountry, setBlCountry] = useBlCountry(
  //   disabledPath ? 'view' : 'new',
  //   'import',
  //   822
  // );
  // const [invoiceReqBlCountry] = useInvoiceRequestBlCountry(
  //   disabledPath ? 'view' : 'new',
  //   'import',
  //   822
  // );
  // const activeBlCountry = isInstructionDashboardNewForm ? invoiceReqBlCountry : blCountry;

  const [clearable, setClearable] = useState(true);
  const data: any = useSelector((state: RootState) => state.invoiceRequestContainer.data);
  const localstorageFlag: any = useSelector((state: RootState) => state.invoiceRequestContainer.localstorage);
  const currencyList = useSelector((state: RootState) => state.standaloneInvoice.countryDDList);
  const [invalidContainers, setInvalidContainers] = useState<string[]>([]);
  const [subLocationOptionsByZone, setSubLocationOptionsByZone] = useState<Record<string, any[]>>({});
  const [bulkValues, setBulkValues] = useState<Record<string, any>>({
    deliveryZone: '',
    subLocation: '',
    modeOfTransport: '',
    typeOfTrailer: '',
    needExtensionFor: '0',
    plannedPickupDate: null,
    currency: '',
  });

  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const extensionTypeOption = useSelector(
    (state: RootState) => state.invoiceRequestContainer.extensionTypeOptions
  );
  // const deleveryLocationList = useSelector(
  //   (state: RootState) => state.invoiceRequestContainer.deleveryTypeLocation
  // );
  // const returnTypeList = useSelector(
  //   (state: RootState) => state.invoiceRequestContainer.returnTypeLocation
  // );
  const selectedLinerId = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const dataCountry = useDataCountry();

  const allContainersValue = (
    field:
      | 'deliveryZone'
      | 'subLocation'
      | 'modeOfTransport'
      | 'typeOfTrailer'
      | 'needExtensionFor'
      | 'plannedPickupDate'
      | 'currency'
  ) => {
    if (!data?.length) return field === 'needExtensionFor' ? '0' : '';

    const firstValue = data[0]?.[field];
    const normalizedFirstValue =
      field === 'plannedPickupDate' && firstValue
        ? new Date(firstValue).getTime()
        : String(firstValue ?? '');
    const allSame = data.every((item: any) => {
      const value = item?.[field];
      const normalizedValue =
        field === 'plannedPickupDate' && value
          ? new Date(value).getTime()
          : String(value ?? '');
      return normalizedValue === normalizedFirstValue;
    });

    return allSame ? firstValue : field === 'needExtensionFor' ? '0' : '';
  };

  const containerDataKey = `${blIdProp ?? ''}:${data
    ?.map(
      (item: any) =>
        `${item.invoiceRequestContainerId ?? ''}:${item.invoiceRequestInstructionId ?? ''}:${item.containerNo ?? ''}`
    )
    .join('|') ?? ''}`;

  useEffect(() => {
    setBulkValues({
      deliveryZone: allContainersValue('deliveryZone'),
      subLocation: allContainersValue('subLocation'),
      modeOfTransport: allContainersValue('modeOfTransport'),
      typeOfTrailer: allContainersValue('typeOfTrailer'),
      needExtensionFor: allContainersValue('needExtensionFor'),
      plannedPickupDate: allContainersValue('plannedPickupDate'),
      currency: allContainersValue('currency'),
    });
  }, [containerDataKey]);

  const allNeedExtensionFor = bulkValues.needExtensionFor;
  const allPlannedPickupDate = bulkValues.plannedPickupDate;
  const allCurrency = bulkValues.currency;
  const allDeliveryZone = bulkValues.deliveryZone;
  const allSubLocation = bulkValues.subLocation;
  const allModeOfTransport = bulkValues.modeOfTransport;
  const allTypeOfTrailer = bulkValues.typeOfTrailer;

  const getDeliveryZoneLabel = (value: any) =>
    deliveryZoneList.find((option) => String(option.value) === String(value))?.label ?? '';

  const isQuaySideStripping = (deliveryZone: any) =>
    /quay[- ]?side\s*stripping|d[eé]potage\s*à\s*quai/i.test(
      getDeliveryZoneLabel(deliveryZone)
    );

  const getModeOfTransportOptions = (deliveryZone: any, hazardous = false) => {
    const deliveryZoneId = String(deliveryZone ?? '');
    const isDelZ1 = deliveryZoneId === '1';
    const isDelZ2 = deliveryZoneId === '2';
    const isDelZ3 = deliveryZoneId === '3';
    const isDelZ4 = deliveryZoneId === '4';
    const isDelZ1ToZ4 = isDelZ1 || isDelZ2 || isDelZ3 || isDelZ4;
    const filterCustomerTransport =
      dataCountry === country &&
      String(linerId) === '24118' &&
      isDelZ1ToZ4 &&
      !hazardous;

    return filterCustomerTransport
      ? modeOfTransportList.filter((option) => String(option.value) !== '1')
      : modeOfTransportList;
  };

  const loadSubLocations = (deliveryZone: any) => {
    const zoneKey = String(deliveryZone ?? '');
    const deliveryZoneLabel = getDeliveryZoneLabel(deliveryZone);
    if (
      !zoneKey ||
      !deliveryZoneLabel ||
      !linerId ||
      !country ||
      subLocationOptionsByZone[zoneKey]?.length
    ) return;

    dispatch(
      getInvoiceRequestSubLocationList({
        linerId,
        deliveryZoneId: deliveryZone,
        deliveryZone: deliveryZoneLabel,
        countryCode: country,
      })
    )
      .unwrap()
      .then((options: any) =>
        setSubLocationOptionsByZone((current) => ({
          ...current,
          [zoneKey]: options ?? [],
        }))
      )
      .catch(() =>
        setSubLocationOptionsByZone((current) => ({ ...current, [zoneKey]: [] }))
      );
  };

  const TableCellDeliveryZone = (rowData: any) => {
    const { containerNo, deliveryZone } = rowData.row.original;
    if (disableFields) return <span>{getDeliveryZoneLabel(deliveryZone)}</span>;

    return (
      <Form.Select
        className='fs--1 form-control form-select'
        value={deliveryZone || ''}
        onChange={(event) => {
          const value = event.target.value;
          const label = getDeliveryZoneLabel(value);
          dispatch(updateContainerTransportField({ containerNo, field: 'deliveryZone', value, label }));
          loadSubLocations(value);
          dispatch(setDirty());
        }}
      >
        <option value=''>Select</option>
        {deliveryZoneList.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    );
  };

  const TableCellSubLocation = (rowData: any) => {
    const { containerNo, deliveryZone, subLocation } = rowData.row.original;
    const options = subLocationOptionsByZone[String(deliveryZone ?? '')] ?? [];
    if (disableFields) {
      return <span>{options.find((option: any) => String(option.value) === String(subLocation))?.label ?? ''}</span>;
    }

    return (
      <Form.Select
        className='fs--1 form-control form-select'
        disabled={!deliveryZone || isQuaySideStripping(deliveryZone)}
        value={subLocation || ''}
        onFocus={() => loadSubLocations(deliveryZone)}
        onChange={(event) => {
          const value = event.target.value;
          const label = options.find((option: any) => String(option.value) === value)?.label ?? '';
          dispatch(updateContainerTransportField({
            containerNo,
            field: 'subLocation',
            value,
            label,
          }));
          dispatch(setDirty());
        }}
      >
        <option value=''>Select</option>
        {options.map((option: any) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    );
  };

  const TableCellModeOfTransport = (rowData: any) => {
    const { containerNo, deliveryZone, modeOfTransport, isHazardous: rowIsHazardous } = rowData.row.original;
    const options = getModeOfTransportOptions(deliveryZone, !!rowIsHazardous);
    if (disableFields) {
      return <span>{modeOfTransportList.find((option) => String(option.value) === String(modeOfTransport))?.label ?? ''}</span>;
    }

    return (
      <Form.Select
        className='fs--1 form-control form-select'
        disabled={!deliveryZone}
        value={modeOfTransport || ''}
        onChange={(event) => {
          dispatch(updateContainerTransportField({
            containerNo,
            field: 'modeOfTransport',
            value: event.target.value,
          }));
          dispatch(setDirty());
        }}
      >
        <option value=''>Select</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    );
  };

  const TableCellHazardous = (rowData: any) => {
    const { containerNo, isHazardous: rowIsHazardous } = rowData.row.original;
    if (disableFields) return <span>{rowIsHazardous ? 'Yes' : 'No'}</span>;

    return (
      <Form.Check
        type='checkbox'
        aria-label={`Hazardous container ${containerNo}`}
        checked={!!rowIsHazardous}
        onChange={(event) => {
          dispatch(updateContainerTransportField({
            containerNo,
            field: 'isHazardous',
            value: event.target.checked,
          }));
          dispatch(setDirty());
        }}
      />
    );
  };

  const TableCellTypeOfTrailer = (rowData: any) => {
    const { containerNo, modeOfTransport, typeOfTrailer } = rowData.row.original;
    if (disableFields) {
      return <span>{typeOfTrailerList.find((option) => String(option.value) === String(typeOfTrailer))?.label ?? ''}</span>;
    }

    return (
      <Form.Select
        className='fs--1 form-control form-select'
        disabled={String(modeOfTransport) === '1' || !modeOfTransport}
        value={typeOfTrailer || ''}
        onChange={(event) => {
          dispatch(updateContainerTransportField({
            containerNo,
            field: 'typeOfTrailer',
            value: event.target.value,
          }));
          dispatch(setDirty());
        }}
      >
        <option value=''>Select</option>
        {typeOfTrailerList.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    );
  };

  // const validateExtensionTypes = () => {
  //   const updatedData = data.map((item: any) => {
  //     if (item.needExtensionFor === "0" || item.needExtensionFor === 0 || !item.needExtensionFor) {
  //       return {
  //         ...item,
  //         needExtensionFor: extensionTypeOption[0]?.value || ""
  //       };
  //     }
  //     return item;
  //   });
  //   const extensionTypes = updatedData
  //     .filter((item: any) => item.needExtensionFor)
  //     .map((item: any) => item.needExtensionFor);
  //   if (extensionTypes.length === 0) {
  //     setExtensionTypeError("");
  //     setInvalidContainers([]);
  //     return true;
  //   }
  //   const firstValue = String(extensionTypes[0]);
  //   const invalidContainersList = updatedData
  //     .filter(
  //       (item: any) =>
  //         item.needExtensionFor &&
  //         String(item.needExtensionFor) !== firstValue
  //     )
  //     .map((item: any) => item.containerNo);
  //   const allSame = invalidContainersList.length === 0;
  //   if (!allSame) {
  //     setInvalidContainers(invalidContainersList);
  //     return false;
  //   }
  //   setExtensionTypeError("");
  //   setInvalidContainers([]);
  //   return true;
  // };

  const TableCell = (rowData: any) => {
    const { blContainerId, containerNo, plannedPickupDate } = rowData.row.original;

    if (disableFields) {
      return (
        <span>
          {plannedPickupDate ? moment(
            moment
              .utc(plannedPickupDate)
              .toDate()
          ).format(getDateFormat().toLocaleUpperCase()) : ''}
        </span>
      );
    }
    return (
      <>
        <DatePicker
          selected={plannedPickupDate}
          portalId='root'
          onChange={(date) => {
            dispatch(
              updateSelectedPickupDate({
                containerNo,
                plannedPickupDate: date
              })
            );
            dispatch(setDirty());
          }}
          className='fs--2 form-control'
          timeIntervals={5}
          dateFormat={getDateFormat()}
          isClearable={clearable}
          popperProps={{
            strategy: 'fixed',
          }}
          disabled={disableFields}
          minDate={new Date()}
        />
      </>
    );
  };

  // const TableCell2 = (rowData: any) => {
  //   const { blContainerId, containerNo, containerReturnDate } = rowData.row.original;
  //   if (disableFields) {
  //     return (
  //       <span>
  //         {containerReturnDate ? moment(
  //           moment
  //             .utc(containerReturnDate)
  //             .toDate()
  //         ).format(getDateFormat().toLocaleUpperCase()) : ''}
  //       </span>
  //     );
  //   }
  //   return (
  //     <>
  //       <DatePicker
  //         selected={containerReturnDate}
  //         portalId='root'
  //         onChange={(date:  Date | null) => {
  //           dispatch(
  //             updateSelectedReturnDate({
  //               containerNo,
  //               containerReturnDate: date
  //             })
  //           );
  //           dispatch(setDirty());
  //         }}
  //         onBlur={() => setValue('containerReturnDate', containerReturnDate, { shouldDirty: false })}
  //         className='fs--2 form-control'
  //         timeIntervals={5}
  //         dateFormat={getDateFormat()}
  //         isClearable={clearable}
  //         popperProps={{
  //           strategy: 'fixed',
  //         }}
  //         disabled={
  //           false
  //         }
  //         minDate={new Date()}
  //       />
  //     </>
  //   );
  // };

  const TableCellReturnLocation = (rowData: any) => {
    const { containerNo, needExtensionFor } = rowData.row.original;
    const isInvalid = invalidContainers.includes(containerNo);

    if (!disableFields) {
      return (
        <Form.Select
          disabled={disableFields}
          value={needExtensionFor || ''}
          onChange={(e) => {
            const value = e.target.value;
            dispatch(setDirty());
            dispatch(
              updateSelectedContainerNo({
                containerNo,
                needExtensionFor: value
              })
            );
          }}
          className={`fs--1 form-control form-select ${isInvalid ? "border-danger" : ""}`}
          style={isInvalid ? { borderColor: "red", boxShadow: "0 0 0 0.2rem rgba(220, 53, 69, 0.25)" } : {}}
        >
          {
            <>
              {extensionTypeOption?.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </>
          }
        </Form.Select>
      );
    } else {
      return <span>{extensionTypeOption?.find?.((i) => i.value == needExtensionFor)?.text || ''}</span>;
    }
  };

  // const TableCellDeleveryLocType = (rowData: any) => {
  //   const { blContainerId, containerNo, deliveryLocationType, needExtensionFor } = rowData.row.original;
  //   if (!disableFields) {
  //     return (
  //       <Form.Select
  //         disabled={disableFields}
  //         value={deliveryLocationType || ''}
  //         onChange={(e) => {
  //           dispatch(setDirty());
  //           dispatch(
  //             updateSelectedDeleveryLocTypeOnContainer({
  //               containerNo,
  //               deliveryLocationType: e.target.value
  //             })
  //           );
  //         }}
  //         className='fs--1 form-control  form-select'>
  //         {
  //           <>
  //             {deleveryLocationList?.map((option: any) => (
  //               <option key={option.value} value={option.value}>
  //                 {option.text}
  //               </option>
  //             ))}
  //           </>
  //         }
  //       </Form.Select>
  //     );
  //   } else {
  //     return (
  //       <span>
  //         {deleveryLocationList?.find?.((i) => i.value == deliveryLocationType)?.text || ''}
  //       </span>
  //     );
  //   }
  // };

  // const TableCellReturnLocType = (rowData: any) => {
  //   const { blContainerId, containerNo, returnLocation, needExtensionFor } = rowData.row.original;
  //   if (!disableFields) {
  //     return (
  //       <Form.Select
  //         disabled={disableFields}
  //         value={returnLocation || ''}
  //         onChange={(e) => {
  //           dispatch(setDirty());
  //           dispatch(
  //             updateSelectedReturnLocTypeOnContainer({
  //               containerNo,
  //               returnLocation: e.target.value
  //             })
  //           );
  //         }}
  //         className='fs--1 form-control  form-select'>
  //         {
  //           <>
  //             {returnTypeList?.map((option: any) => (
  //               <option key={option.value} value={option.value}>
  //                 {option.text}
  //               </option>
  //             ))}
  //           </>
  //         }
  //       </Form.Select>
  //     );
  //   } else {
  //     return (
  //       <span>
  //         {returnTypeList?.find?.((i) => i.value == returnLocation)?.text || ''}
  //       </span>
  //     );
  //   }
  // };

  const TableCellCurrency = (rowData: any) => {
    const { blContainerId, containerNo, currency } = rowData.row.original;
    if (!disableFields) {
      return (
        <Form.Select
          disabled={disableFields}
          value={currency || ''}
          onChange={(e) => {
            dispatch(setDirty());
            dispatch(
              updateSelectedCCyOnContainer({
                containerNo,
                currency: e.target.value
              })
            );
          }}
          className='fs--1 form-control  form-select'>
          <option key={''} value={''}></option>
          {currencyList.map((option: any) => (
            <option key={option.currencyCode} value={option.currencyCode}>
              {option.currencyShortName}
            </option>
          ))}
        </Form.Select>
      );
    } else {
      return (
        <span>
          {currency}
        </span>
      );
    }
  };

  // useEffect(() => {
  //   const storageKey = 'invoiceRequestContainerFormData';
  //   const data1 = localStorage.getItem(storageKey);
  //   if (data1) {
  //     try {
  //       const parsed = JSON.parse(data1);
  //       const containerNos = Object.keys(parsed.selectedDate || {}).filter(key => key !== 'intended');
  //       const containerDataForRedux = containerNos.map(containerNo => ({
  //         id: null,
  //         containerNo,
  //         plannedPickupDate: parsed.selectedDate?.[containerNo] ? new Date(parsed.selectedDate[containerNo]) : null,
  //         containerReturnDate: null,
  //         returnLocation: '0',
  //         needExtensionFor: parsed.selectedNeedExtensionFor?.[containerNo] ?? '0',
  //         deliveryLocationType: deleveryLocationList.some(x => x.value == parsed.selectedPickupLocation?.[containerNo]) ?
  //           parsed.selectedPickupLocation?.[containerNo] ?? '0' : deleveryLocationList?.[0]?.value ?? '0',
  //         currency: parsed.currency?.[containerNo] ?? ''
  //       }));
  //       if (containerDataForRedux.length > 0) {
  //         dispatch(setContainerData(containerDataForRedux));
  //       }
  //       localStorage.removeItem(storageKey);
  //     } catch (e) {
  //       console.error("Failed to map data from localStorage", e);
  //       localStorage.removeItem(storageKey);
  //     }
  //   }
  // }, [dispatch, disableFields, setValue]);

  useEffect(() => {
    // if (!localstorageFlag) {
      if (country)
        dispatch(extensionTypeList({ partnerCountry: country, linerId })).unwrap().then((data) => {
          if (disabledPath || !isDemurrageDetentionSelected) return
          dispatch(updateSelectedneedExtensionFor(data.value))
        })
    // }
    // if (blCountry && linerId) {
    //   dispatch(deleveryLocTypeList({ dataCountry: blCountry, linerId }))
    //   dispatch(returnLocTypeList({ dataCountry: blCountry, linerId }))
    // }

    i18n.changeLanguage(
      `${country}_${language}`
    );
  }, [country, linerId, language, isDemurrageDetentionSelected]);

  useEffect(() => {
    if (profileDetails?.partnerType === 'customer') {
      dispatch(getCurrencyDDList())
    } else if (profileDetails?.partnerType === 'liner') {
      dispatch(getCurrencyDDListByBankNm({ country: dataCountry }))
    }
  }, [profileDetails.partnerType]);

  useEffect(() => {
    const deliveryZones = Array.from(
      new Set(data.map((item: any) => String(item.deliveryZone ?? '')).filter(Boolean))
    );
    deliveryZones.forEach((deliveryZone) => loadSubLocations(deliveryZone));
  }, [data, linerId, country, deliveryZoneList]);

  // Default Currency to XOF for CI (Demurrage / Detention container grid)
  useEffect(() => {
    if (disableFields) return;
    if (!isDemurrageDetentionSelected) return;
    if (!['CI'].includes(country ?? '')) return;
    if (!data?.length) return;

    const xofOption = currencyList?.find(
      (option: any) =>
        String(option.currencyShortName).toUpperCase() === 'XOF' ||
        String(option.currencyCode).toUpperCase() === 'XOF'
    );
    const xofValue = xofOption?.currencyCode ?? 'XOF';

    const hasEmptyCurrency = data.some((item: any) => !item.currency);
    if (hasEmptyCurrency) {
      data.forEach((item: any) => {
        if (!item.currency) {
          dispatch(
            updateSelectedCCyOnContainer({
              containerNo: item.containerNo,
              currency: xofValue,
            })
          );
        }
      });
    }

  }, [disableFields, isDemurrageDetentionSelected, country, data, currencyList, dispatch]);

  const contactDetailsColumns: IDataTableColumn[] = [
    {
      accessor: 'blContainerId',
      Header: 'blContainerId',
    },
    {
      accessor: 'containerNo',
      Header: t('resource_2:containerNo'),
      width: 200,
      maxWidth: 150,
    },
    {
      accessor: 'isHazardous',
      Header: 'Hazardous',
      width: 120,
      maxWidth: 120,
      Cell: TableCellHazardous,
    },
    {
      accessor: 'deliveryZone',
      Header: t('resource_2:deliveryZone'),
      width: 200,
      maxWidth: 200,
      Cell: TableCellDeliveryZone,
    },
    {
      accessor: 'subLocation',
      Header: t('resource_2:subLocation'),
      width: 200,
      maxWidth: 200,
      Cell: TableCellSubLocation,
    },
    {
      accessor: 'modeOfTransport',
      Header: t('resource_3:modeOfTransport'),
      width: 200,
      maxWidth: 200,
      Cell: TableCellModeOfTransport,
    },
    {
      accessor: 'typeOfTrailer',
      Header: t('resource_3:typeOfTrailer'),
      width: 200,
      maxWidth: 200,
      Cell: TableCellTypeOfTrailer,
    },
    ...(isDemurrageDetentionSelected ? [
      {
        accessor: 'needExtensionFor',
        Header: t('resource_3:needExtensionFor'),
        width: 220,
        maxWidth: 220,
        Cell: TableCellReturnLocation,
      },
      {
        accessor: 'IntendedDate',
        Header: t('resource_3:plannedPickupDate'),
        width: 220,
        maxWidth: 220,
        Cell: TableCell,
      },
    ] : []),
    // {
    //   accessor: 'ReturnDate',
    //   Header: t('resource_3:returnDate'),
    //   width: 220,
    //   maxWidth: 220,
    //   Cell: TableCell2,
    // },
    // {
    //   accessor: 'returnLocation',
    //   Header: t('resource_3:returnLocation') ,
    //   width: 220,
    //   maxWidth: 220,
    //   Cell: TableCellReturnLocType,
    // },
    // ['TG','CI', 'UG', 'TZ', 'MZ', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') || (blCountry == 'CM' && selectedLinerId == '24118') || (blCountry == 'CG' && selectedLinerId == '24118') ?
    //   {
    //     accessor: 'deleveryLocType',
    //     Header: t('resource_3:deleveryLocType'),
    //     width: 220,
    //     maxWidth: 220,
    //     Cell: TableCellDeleveryLocType,
    //   } : {
    //     accessor: 'deleveryLocType',
    //     Header: '',
    //     width: 0,
    //     maxWidth: 0,
    //   },
    ...(isDemurrageDetentionSelected ? [
      {
        accessor: 'currency',
        Header: t('resource_1:currency'),
        width: 220,
        maxWidth: 220,
        Cell: TableCellCurrency,
      },
    ] : [])
  ];

  const getHiddenCols = () => {
    if (country == 'CI' && selectedLinerId == '24118') {
      return ['blContainerId', 'ReturnDate', 'returnLocation', 'deleveryLocType'];
    }
    // if (['KE', 'UG', 'TZ', 'MZ'].includes(blCountry) && disableFields) {
    //   return ['blContainerId', 'ReturnDate', 'returnLocation'];
    // }
    // else if (blCountry == 'ZA' && selectedLinerId == '24118') {
    //   return ['blContainerId'];
    // }
    // else if (blCountry == 'CM' && selectedLinerId == '24118' && disableFields) {
    //   return ['blContainerId', 'ReturnDate', 'returnLocation'];
    // }
    // else if (blCountry == 'CG' && selectedLinerId == '24118' && disableFields) {
    //   return ['blContainerId', 'ReturnDate', 'returnLocation'];
    // }
    else {
      return ['blContainerId','ReturnDate', 'returnLocation', 'deleveryLocType'];
    }
  };

  const hiddenCols = useMemo(() => getHiddenCols(), [country, selectedLinerId, disableFields]);

  useEffect(() => {
    dispatch(
      updateColsDataTable({
        INVOICE_REQUEST_CONTAINER: contactDetailsColumns
          .map((column) => column.accessor)
          .filter(
            (accessor): accessor is string =>
              !!accessor && !hiddenCols.includes(accessor)
          ),
      })
    );
  }, [dispatch, isDemurrageDetentionSelected, hiddenCols]);

  return (
    <>
      {!disableFields && (
        <>
          <div className='col-lg-6 mb-3'>
            <Form.Group controlId='invoiceRequestContainer.deliveryZone'>
              <Form.Label className='fs--1'>
                <span className='mandatory'>*</span>{t('resource_2:deliveryZone')} For All Container
              </Form.Label>
              <Form.Select
                className='fs--1'
                value={`${allDeliveryZone ?? ''}`}
                onChange={(event) => {
                  const value = event.target.value;
                  setBulkValues((current) => ({
                    ...current,
                    deliveryZone: value,
                    subLocation: '',
                    modeOfTransport: '',
                    typeOfTrailer: '',
                  }));
                  dispatch(updateSelectedDeliveryZone({ value, label: getDeliveryZoneLabel(value) }));
                  loadSubLocations(value);
                  dispatch(setDirty());
                }}
              >
                <option value=''>Select</option>
                {deliveryZoneList.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>

          <div className='col-lg-6 mb-3'>
            <Form.Group controlId='invoiceRequestContainer.subLocation'>
              <Form.Label className='fs--1'>
                {!isQuaySideStripping(allDeliveryZone) && <span className='mandatory'>*</span>}
                {t('resource_2:subLocation')} For All Container
              </Form.Label>
              <Form.Select
                className='fs--1'
                disabled={!allDeliveryZone || isQuaySideStripping(allDeliveryZone)}
                value={`${allSubLocation ?? ''}`}
                onFocus={() => loadSubLocations(allDeliveryZone)}
                onChange={(event) => {
                  const value = event.target.value;
                  const options = subLocationOptionsByZone[String(allDeliveryZone ?? '')] ?? [];
                  const label = options.find((option: any) => String(option.value) === value)?.label ?? '';
                  setBulkValues((current) => ({ ...current, subLocation: value }));
                  dispatch(updateSelectedSubLocation({ value, label }));
                  dispatch(setDirty());
                }}
              >
                <option value=''>Select</option>
                {(subLocationOptionsByZone[String(allDeliveryZone ?? '')] ?? []).map((option: any) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>

          <div className='col-lg-6 mb-3'>
            <Form.Group controlId='invoiceRequestContainer.modeOfTransport'>
              <Form.Label className='fs--1'>
                <span className='mandatory'>*</span>{t('resource_3:modeOfTransport')} For All Container
              </Form.Label>
              <Form.Select
                className='fs--1'
                disabled={!allDeliveryZone}
                value={`${allModeOfTransport ?? ''}`}
                onChange={(event) => {
                  const value = event.target.value;
                  setBulkValues((current) => ({
                    ...current,
                    modeOfTransport: value,
                    typeOfTrailer: String(value) === '1' ? '' : current.typeOfTrailer,
                  }));
                  dispatch(updateSelectedModeOfTransport(value));
                  dispatch(setDirty());
                }}
              >
                <option value=''>Select</option>
                {getModeOfTransportOptions(
                  allDeliveryZone,
                  data.every((item: any) => !!item.isHazardous)
                ).map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>

          <div className='col-lg-6 mb-3'>
            <Form.Group controlId='invoiceRequestContainer.typeOfTrailer'>
              <Form.Label className='fs--1'>
                {String(allModeOfTransport) === '2' && <span className='mandatory'>*</span>}
                {t('resource_3:typeOfTrailer')} For All Container
              </Form.Label>
              <Form.Select
                className='fs--1'
                disabled={!allModeOfTransport || String(allModeOfTransport) === '1'}
                value={`${allTypeOfTrailer ?? ''}`}
                onChange={(event) => {
                  const value = event.target.value;
                  setBulkValues((current) => ({ ...current, typeOfTrailer: value }));
                  dispatch(updateSelectedTypeOfTrailer(value));
                  dispatch(setDirty());
                }}
              >
                <option value=''>Select</option>
                {typeOfTrailerList.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </>
      )}

      {(!disableFields && isDemurrageDetentionSelected) ? <div className='col-lg-6 mb-3'>
        <Form.Group controlId='invoiceRequestContainer.needExtensionFor'>
          <Form.Label className='fs--1'>
            {t('resource_5:needExtensionForAllContainer')}&nbsp;
          </Form.Label>
          <Form.Select
            aria-label={t('resource_2:pickUpLoc')}
            className='fs--1'
            disabled={disableFields}
            value={`${allNeedExtensionFor ?? '0'}`}
            onChange={(e) => {
              const value = e.target.value;
              setBulkValues((current) => ({ ...current, needExtensionFor: value }));
              dispatch(updateSelectedneedExtensionFor(value))
              dispatch(setDirty());
            }}
          >
            {extensionTypeOption?.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.text}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </div> : ""}
      {(!disableFields && isDemurrageDetentionSelected) ?
        <div className='col-lg-6 mb-3'>
          <Form.Group controlId='invoiceRequestContainer.plannedPickupDate'>
            <Form.Label className='fs--1'>
              {t('resource_5:plannedPickupDateForAllContainer')}{' '}
              <FontAwesomeIcon
                icon={faCircleInfo}
                title={t('resource_5:calculatationTextDemurrageStorageDetension')}
                className='me-2'
              />
            </Form.Label>
            <div className='releaseDate'>
              <DatePicker
                selected={allPlannedPickupDate ? new Date(allPlannedPickupDate) : null}
                onChange={(date: any) => {
                  dispatch(setDirty());
                  setBulkValues((current) => ({ ...current, plannedPickupDate: date }));
                  dispatch(
                    updateSelectedPlannedPickupDate(date)
                  );
                }}
                className='fs--2 form-control'
                timeIntervals={5}
                dateFormat={getDateFormat()}
                isClearable={clearable}
                popperProps={{
                  strategy: 'fixed',
                }}
                minDate={new Date()}
                disabled={disableFields}
              />
            </div>
          </Form.Group>
        </div> : ""}
      {(!disableFields && isDemurrageDetentionSelected && ['CI'].includes(country ?? '') && selectedLinerId == '24118') ? <div className='col-lg-6 mb-3'>
        <Form.Group controlId='invoiceRequestContainer.currency'>
          <Form.Label className='fs--1'>
            {['CI'].includes(country ?? '') ? "" : <span className='mandatory'>*</span>}
            {t('resource_5:currencyForAllContainer')}&nbsp;
          </Form.Label>
          <Form.Select
            aria-label={t('resource_2:currency')}
            className='fs--1'
            disabled={disableFields}
            value={`${allCurrency ?? ''}`}
            onChange={(e) => {
              const value = e.target.value;
              dispatch(setDirty());
              setBulkValues((current) => ({ ...current, currency: value }));
              dispatch(updateSelectedCcy(value))
            }}
          >
            <option key={''} value={''}></option>
            {currencyList?.map((option: any) => (
              <option key={option.currencyCode} value={option.currencyCode}>
                {option.currencyShortName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </div> : ""}

      {/* {(!disableFields && (blCountry ==='ZA' && selectedLinerId ==='24118')) ?
        <div className='col-lg-6 mb-3'>
          <Form.Group controlId='invoiceRequestContainer.returnDate'>
            <Form.Label className='fs--1'>
              Container Return Date
            </Form.Label>
            <div className='releaseDate'>
              <DatePicker
                selected={watch('containerReturnDate')}
                onChange={(date: Date | null) => {
                  dispatch(setDirty());
                  dispatch(
                    updateSelectedContainerReturnDate(date)
                  );
                  setValue('containerReturnDate', date)
                }}
                className='fs--2 form-control'
                timeIntervals={5}
                dateFormat={getDateFormat()}
                isClearable={clearable}
                popperProps={{
                  strategy: 'fixed',
                }}
                minDate={new Date()}
                disabled={disableFields}
              />
            </div>
          </Form.Group>
        </div>
        : ""} */}

      {/* {(!disableFields && (blCountry ==='ZA' && selectedLinerId ==='24118')) ? <div className='col-lg-6 mb-3'>
        <Form.Group controlId='invoiceRequestContainer.returnLocation'>
          <Form.Label className='fs--1'>
            Return Location Type
          </Form.Label>
          <Form.Select
            {...register('returnLocation')}
            className='fs--1'
            value={`${watch('returnLocation')}`}
            onChange={(e) => {
              dispatch(setDirty());
              dispatch(updateSelectedReturnLocType(e.target.value))
              setValue('returnLocation', e.target.value, { shouldDirty: true })
            }}
          >
            {returnTypeList?.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.text}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </div> : ""} */}

      <div
        className='col-lg-12 mb-2 demmurageTable'
        style={{ zIndex: 1 }}>
        {(data?.length > 0 && country && selectedLinerId) && <DataTable
          data={data}
          gridName='INVOICE_REQUEST_CONTAINER'
          columns={contactDetailsColumns}
          sortable={false}
          searchable={false}
          showColumnFilter={false}
          selection={false}
          perPage={10}
          pagination={false}
          showExport={false}
          uniqueFilterKey='invoiceRequestContainer'
          autoHeight={true}
          staticHiddenCols={hiddenCols}
          defaultHiddenCols={hiddenCols}
        />}
      </div>

    </>
  );
};

export default InvoiceRequestContainerDetails;
